import LayoutContainer from 'components/Common/LayoutContainer'
import Heading from 'LuxKit/Typography/Heading'
import Pane from 'components/Common/Pane'
import Group from 'components/utils/Group'
import React, { memo, useMemo } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import TextLink from 'LuxKit/TextLink'
import BodyText from 'LuxKit/Typography/BodyText'
import { CRUISE_LINE_INFO, DEFAULT_CRUISE_LINE_FINE_PRINT_LINK } from 'constants/cruise'

interface Props {
  cruiseLine: App.CruiseLine
}

function CruiseFinePrint({ cruiseLine }: Props) {
  const intl = useIntl()
  const { code: cruiseLineCode, name: cruiseLineName } = cruiseLine

  const termsAndConditionsLink = useMemo(() => {
    if (cruiseLineCode && cruiseLineCode in CRUISE_LINE_INFO) {
      return CRUISE_LINE_INFO[cruiseLineCode as keyof typeof CRUISE_LINE_INFO].finePrintLink
    }

    return DEFAULT_CRUISE_LINE_FINE_PRINT_LINK
  }, [cruiseLineCode])

  return (
    <Pane padding="32 32">
      <Group direction="vertical" gap={48}>
        <Heading
          align="center"
          variant="heading2"
        >
          <FormattedMessage
            id="5yHiib+00m"
            defaultMessage="Booking Terms & Conditions"
            description="Heading for cruise booking terms and conditions section"
          />
        </Heading>
        <Pane>
          <LayoutContainer>
            <Group direction="vertical" gap={16}>
              <BodyText variant="medium">
                <FormattedMessage
                  id="W5qE0pwnnO"
                  defaultMessage="By completing your booking, you agree to the terms and conditions set forth by the cruise line operator. We acts solely as an intermediary and is not responsible for changes, cancellation policies, or specific rules established by the cruise company."
                  description="Notice about agreeing to terms when booking a cruise"
                />
              </BodyText>
              <BodyText variant="medium">
                <FormattedMessage
                  id="Pm/mH/9JTI"
                  defaultMessage="It is essential that you review and accept the official Terms and Conditions before finalizing your purchase. All policies regarding luggage, boarding, documentation, cancellations, and refunds are detailed in the operator’s official document."
                  description="Notice about reviewing terms before purchase in the cancellation flow"
                />
              </BodyText>
              <TextLink size="medium" href={termsAndConditionsLink} target="_blank" weight="bold" underline>
                {intl.formatMessage(
                  {
                    id: 's4f6Kvi+cD',
                    defaultMessage: 'Click here to view the Terms and Conditions for {cruiseLineName}',
                    description: 'Link text to view cruise line terms and conditions',
                  },
                  { cruiseLineName },
                )}
              </TextLink>
            </Group>
          </LayoutContainer>
        </Pane>
      </Group>
    </Pane>
  )
}

export default memo(CruiseFinePrint)
